<template>
<div class="d-flex" id="wrapper">
  <SideBar />
  <div id="page-content-wrapper">
    <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
      <div>
        <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
        </button>

        <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
        </button>
      </div>
      <div class="d-flex">
        <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
        <p class="text-primary mb-0 hover-cursor">&nbsp;Order / End Rent</p>
      </div>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              {{ admin }}
            </a>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
              <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
              <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
            </div>
          </li>
        </ul>
      </div>
    </nav>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 grid-margin stretch-card card-div">
          <div class="container">
            <h5 class="card-title mb-4">End Rent</h5>
            <div class="col-lg-12 px-0">
              <div class="container">
                <div class="row">
                  <div class="col-lg-4 col-sm mobile-div pl-0">
                    <div>Start</div>
                    <input type="date" class="form-control" name="pickup_schedule" v-model="startDate">
                  </div>
                  <div class="col-lg-4 col-sm mobile-div px-0">
                    <div>End</div>
                    <input type="date" class="form-control" name="pickup_schedule" v-model="endDate">
                  </div>
                  <div class="col-lg-4 col-sm mobile-div mt-4">
                    <button class="btn btn-primary" @click="searchData"> Search </button>
                  </div>
                </div>
              </div>
              <table class="table table-sm table-bordered table-striped table-responsive-sm mt-5">
                <thead class="">
                  <tr>
                    <th>Company / Order ID</th>
                    <th>PIC Asani</th>
                    <th>Product</th>
                    <th>Duration</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="loadingTable == true">
                    <td colspan="5" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                  </tr>
                  <tr v-else-if="loadingTable == false && data.length > 0" v-for="(order,i) in data[page]" :key="`order-${i}`">
                    <td>
                      <div>{{order.companyName}}</div>
                      <div class="text-primary redirect-link" style="width: fit-content" @click.prevent="redirect(order)">{{order.orderCode}}</div>
                    </td>
                    <td class="align-top">{{order.picAsani}}</td>
                    <td>
                      <div v-for="(prod,i) in order.dataProduct" :key="`orderDataProduct-${i}`">
                        <div>{{prod.productName}}</div>
                        <div>{{prod.specification}}</div>
                        <div>Qty {{prod.qty}}</div>
                        <br>
                      </div>
                    </td>
                    <td>
                      <div v-for="(prod,i) in order.dataProduct" :key="`orderedProduct-${i}`">
                        <div>{{prod.tenor}}</div>
                        <div>{{prod.startRent}} - </div>
                        <div>{{prod.endRent}}</div>
                        <br>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div id="wrapperr">
                <div id="c1" style="display: inline-flex;">
                  <div style="margin-right: 10px;">
                    <select class="form-control form-control-sm" v-model="itemPerPage" @change="searchData()">
                      <option :value="10">10</option>
                      <option :value="40">40</option>
                      <option :value="80">80</option>
                    </select>
                  </div>
                  <div class="alignLeft total-data">
                    Total Data {{ totalData }}
                  </div>
                </div>
                <div id="c2" v-if="totalPage > 0">
                  <div class="pagination p8 alignRight">
                    <ul>
                      <a class="is-active link" @click="toDataPage(page-1)" v-if="page != 0">
                        <li> {{'<'}}</li>
                      </a>
                      <a class="page">
                        <li>{{ page + 1 }} of {{ totalPage }} page</li>
                      </a>
                      <a class="is-active link" @click="toDataPage(page + 1)" v-if="page + 1 < totalPage">
                        <li>></li>
                      </a>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import SideBar from '../SideBar'
export default {
  name: 'EndRentPage',
  components: {
    SideBar
  },
  data() {
    return {
      admin: '',
      permission: [],
      startDate: '',
      endDate: '',
      loadingTable: true,
      page: 0,
      totalPage: 0,
      itemPerPage: 10,
      totalData: 0,
      data: [],
    }
  },
  methods: {
    searchData() {
      this.loadingTable = true
      if (this.startDate !== '' && this.endDate !== '') {
        let start = new Date(this.startDate)
        let end = new Date(this.endDate)
        if(start <= end) {
          this.$http.post(
            process.env.ORDER_ENDRENT,
            {
              start: this.startDate,
              end: this.endDate
            },
            {
              timeout: 30 * 1000,
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((res) => {
            console.log(res)
            if(res.status == 200) {
              if(res.data.content.length > 0) {
                const chunk = (arr, size) =>
                Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
                  arr.slice(i * size, i * size + size)
                )
                let result = chunk(res.data.content, this.itemPerPage)
                this.totalPage = result.length
                this.totalData = res.data.content.length,
                this.data = result
                localStorage.setItem('endrent_cache', JSON.stringify({ page: this.page, start: this.startDate, end: this.endDate, itemPerPage: this.itemPerPage }))
                this.loadingTable = false
              } else {
                swal("Sorry", "Data tidak ditemukan.", "error", {
                button: "Close",
                })
                this.loadingTable = false
              }
            } else {
              swal("Sorry", res.data.message, "error", {
              button: "Close",
              })
              this.loadingTable = false
            }
            this.loadingTable = false
          })
          .catch(error => {
            this.loadingTable = false
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          })
        } else {
          swal("Sorry", "Start Date tidak bisa melebihi End Date.", "error", {
          button: "Close",
          })
          this.loadingTable = false
        }
      } else {
        swal("Sorry", "Start Date & End Date harus diisi.", "error", {
          button: "Close",
        })
        this.loadingTable = false
      }
    },
    toDataPage(val) {
      this.page = val
      localStorage.setItem('endrent_cache', JSON.stringify({ page: this.page, start: this.startDate, end: this.endDate, itemPerPage: this.itemPerPage }))
    },
    sidebar() {
      $("#wrapper").toggleClass("toggled");
    },
    toPage(e) {
      localStorage.removeItem('endrent_cache')
      this.$router.push(e)
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem('jwt')
      localStorage.removeItem('admin_name')
      localStorage.removeItem('roles')
      localStorage.removeItem('user_email')
      localStorage.removeItem('admin_id')
      localStorage.removeItem('endrent_cache')
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push('/')
    },
    cekLogin() {
      if (localStorage.getItem('jwt') == null) {
        this.$router.push('/')
      }
    },
    cekPermission() {
      this.permission = localStorage.getItem('roles').replace(/"/g, "").replace("[", "").replace("]", "").split(",")
      for (var i = 0; i < this.permission.length; i++) {
        if (this.permission[i] == "1") {
          this.viewDashboard = true
        }
        if (this.permission[i] == "2.1") {
          this.viewOrder = true
        }
        if (this.permission[i] == "2.2") {
          this.editOrder = true
        }
        if (this.permission[i] == '3.1') {
          this.viewReturn = true
        }
        if (this.permission[i] == '3.2') {
          this.editReturn = true
        }
        if (this.permission[i] == '4.1') {
          this.viewProduct = true
        }
        if (this.permission[i] == '4.2') {
          this.editProduct = true
        }
        if (this.permission[i] == '5.1') {
          this.viewPairing = true
        }
        if (this.permission[i] == '5.2') {
          this.editPairing = true
        }
        if (this.permission[i] == '6') {
          this.viewReconcile = true
        }
        if (this.permission[i] == '7.1') {
          this.viewResolution = true
        }
        if (this.permission[i] == '7.2') {
          this.editResolution = true
        }
        if (this.permission[i] == '8.1') {
          this.viewLessor = true
        }
        if (this.permission[i] == '8.2') {
          this.editLessor = true
        }
        if (this.permission[i] == '9.1') {
          this.viewLessee = true
        }
        if (this.permission[i] == '9.2') {
          this.editLessee = true
        }
        if (this.permission[i] == '10') {
          this.viewEmployee = true
        }
      }
      if (this.viewOrder == false) {
        this.$router.push('/')
      }
    },
    redirect(order) {
      window.open(`/order/detail/${order.orderId}?orderCode=${encodeURIComponent(order.orderCode)}&companyIdDetail=${order.companyId}` , '_blank')
    }
  },
  created() {
    this.cekLogin()
    this.cekPermission()
    this.loadingTable = false
    this.admin = localStorage.getItem('admin_name')
    // window.onpopstate = function () {
    //   location.reload()
    // }
    if (localStorage.getItem('endrent_cache') !== '') {
      let cache = JSON.parse(localStorage.endrent_cache)
      this.page = cache.page
      this.startDate = cache.start
      this.endDate = cache.end
      this.itemPerPage = cache.itemPerPage
      this.searchData()
    }
  }
}
</script>

<style scoped>
.pagination {
  padding: 0px 0;
}
.pagination ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.pagination a {
  display: inline-block;
  padding: 1px 6px;
  color: #222;
}
.p8 a {
  background-color: #2797FB;
  /*margin: auto 5px;*/
  color: #fff;
  /*font-weight: bold;*/
  border: 1px solid #2797FB;
}
.p8 a:hover {
  text-decoration: none;
}
.p8 a.page:hover {
  text-decoration: none;
  color: #fff;
}
.p8 .is-active {
  background-color: #fff;
  color: #2797FB;
}
.alignleft {
  float: left;
}
.alignright {
  float: right;
}
.pagg {
  display: inline-flex;
  overflow: auto;
}
.total-data {
  padding: 11px 0px;
  font-size: 14px;
  color: #343A40;
}
#wrapperr {
  overflow: auto;
  margin: 5px 3px;
}
#c1 {
  float: left;
}
#c2 {
  float: right;
}
.search-table {
  padding-bottom: 7px;
  margin-top: -5px;
  margin-left: -15px;
}
.active {
  color: #2797FB;
}
.right-dropdown {
  margin-left: 7px;
}
.account-div {
  margin: 2px 2px;
}
.right-arrow {
  margin-left: auto;
}
.brand-logo {
  width: 120px;
}
.menu-title {
  margin-left: 1.125rem;
}
.menu-title-order {
  margin-left: 1.95rem;
}
.menu-title-payment {
  margin-left: 1.525rem;
}
ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  /*width: 200px;*/
  /*background-color: #f1f1f1;*/
}
li.sidebar a {
  display: block;
  color: #000;
  padding: 8px 63px;
  text-decoration: none;
}
li a.active {
  background-color: #4CAF50;
  color: white;
}
li a:hover:not(.active) {
  background-color: #2797FB;
  color: white;
}
.redirect-link {
  text-decoration: underline #2797FB;
  cursor: pointer;
}
.nav-side-menu {
  overflow: auto;
  font-family: verdana;
  font-size: 12px;
  font-weight: 200;
  background-color: #2e353d;
  position: fixed;
  top: 0px;
  width: 300px;
  height: 100%;
  color: #e1ffff;
}
.nav-side-menu .brand {
  background-color: #23282e;
  line-height: 50px;
  display: block;
  text-align: center;
  font-size: 14px;
}
.nav-side-menu .toggle-btn {
  display: none;
}
.nav-side-menu ul,
.nav-side-menu li {
  list-style: none;
  padding: 0px;
  margin: 0px;
  line-height: 35px;
  cursor: pointer;
}
.nav-side-menu ul :not(collapsed) .arrow:before,
.nav-side-menu li :not(collapsed) .arrow:before {
  font-family: FontAwesome;
  content: "\f078";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}
.nav-side-menu ul .active,
.nav-side-menu li .active {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
}
.nav-side-menu ul .sub-menu li.active,
.nav-side-menu li .sub-menu li.active {
  color: #d19b3d;
}
.nav-side-menu ul .sub-menu li.active a,
.nav-side-menu li .sub-menu li.active a {
  color: #d19b3d;
}
.nav-side-menu ul .sub-menu li,
.nav-side-menu li .sub-menu li {
  background-color: #181c20;
  border: none;
  line-height: 28px;
  border-bottom: 1px solid #23282e;
  margin-left: 0px;
}
.nav-side-menu ul .sub-menu li:hover,
.nav-side-menu li .sub-menu li:hover {
  background-color: #020203;
}
.nav-side-menu ul .sub-menu li:before,
.nav-side-menu li .sub-menu li:before {
  font-family: FontAwesome;
  content: "\f105";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}
.nav-side-menu li {
  padding-left: 0px;
  border-left: 3px solid #2e353d;
  border-bottom: 1px solid #23282e;
}
.nav-side-menu li a {
  text-decoration: none;
  color: #e1ffff;
}
.nav-side-menu li a i {
  padding-left: 10px;
  width: 20px;
  padding-right: 20px;
}
.nav-side-menu li:hover {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  -ms-transition: all 1s ease;
  transition: all 1s ease;
}
@media (max-width: 767px) {
  .nav-side-menu {
    position: relative;
    width: 100%;
    margin-bottom: 10px;
  }
  .nav-side-menu .toggle-btn {
    display: block;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 10 !important;
    padding: 3px;
    background-color: #ffffff;
    color: #000;
    width: 40px;
    text-align: center;
  }
  .brand {
    text-align: left !important;
    font-size: 22px;
    padding-left: 20px;
    line-height: 50px !important;
  }
}
@media (min-width: 767px) {
  .nav-side-menu .menu-list .menu-content {
    display: block;
  }
}
@media (max-width: 573px) {
  .mobile-div {
    padding: 2px 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Order/OrderEndRentPage.vue